import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import ResuableCard from "./Resuablecard";

export default function ReferralHistoryDesktop({ total, open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* modal panel */}
      <div className="absolute inset-0 mx-auto flex max-w-full items-center justify-center p-4">
        <div className="w-full max-w-[720px] rounded-2xl bg-white p-6 shadow-2xl dark:bg-gray-950">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Earning History
            </h3>
            <button
              className="rounded-full p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800"
              onClick={onClose}
              aria-label="Close"
            >
              <AiOutlineClose size={18} />
            </button>
          </div>
          <div className="max-h-[70vh] overflow-y-auto">
            <ResuableCard total={total} />
          </div>
        </div>
      </div>
    </div>
  );
}
